import React from 'react';

import CartDiscount from './CartDiscount';

import classes from './CartMeta.module.scss';

const CartMeta = ({ cartMetaData, refetchMetaData }) => {
	return (
		<div className={`${classes['card-meta-wrapper']} w-100 d-flex flex-column`}>
			<div
				className={`${classes['card-meta-wrapper__sub-total']} d-flex flex-row align-items-center justify-content-between`}>
				<h6>Sub-total</h6>
				<h5>{cartMetaData?.currency.symbol}{cartMetaData?.subtotal_price}</h5>
			</div>
			{cartMetaData?.deductions && (
				<div
					className={`${classes['card-meta-wrapper__discount']} d-flex flex-row align-items-center justify-content-between`}>
					<h6>Deductions</h6>
					<h5>-{cartMetaData?.currency.symbol}{cartMetaData?.deductions}</h5>
				</div>
			)}
			{cartMetaData?.promotion_amount && (
				<div
					className={`${classes['card-meta-wrapper__discount']} d-flex flex-row align-items-center justify-content-between`}>
					<h6>Promotions</h6>
					<h5>-{cartMetaData?.currency.symbol}{cartMetaData?.promotion_amount}</h5>
				</div>
			)}
			{cartMetaData?.discount_amount && (
				<div
					className={`${classes['card-meta-wrapper__discount']} d-flex flex-row align-items-center justify-content-between`}>
					<h6>Discount</h6>
					<h5>-{cartMetaData?.currency.symbol}{cartMetaData?.discount_amount}</h5>
				</div>
			)}
			<div
				className={`${classes['card-meta-wrapper__total']} d-flex flex-row align-items-center justify-content-between py-3`}>
				<h3>Total</h3>
				<h2>{cartMetaData?.currency.symbol}{cartMetaData?.total_payable_price}</h2>
			</div>
			<div>
				<CartDiscount cartMetaData={cartMetaData} refetchMetaData={refetchMetaData} />
			</div>
		</div>
	);
};

export default React.memo(CartMeta);
